// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0a5d5841","337":"f0e2a774","453":"1908d4b4","455":"e8e54476"}[chunkId] + ".chunk.js";
};